import { Text } from "@shopify/polaris";
import { Handle, Position } from "reactflow";

function AiNode({ id, data }) {
  return (
    <div className="ai-node" onClick={() => data.clickNode(id)}>
      <Handle type="target" position={Position.Left} />
      <br />
      <Text>AI chatbot</Text>
      <br />
      <div className="option">
        <div />
        <Text variant="bodySm">AI can not answer</Text>
        <div />
        <Handle
          type="source"
          id="noAnswer"
          position={Position.Right}
          style={{
            top: "auto",
            bottom: 10,
            right: 5,
          }}
        />
      </div>
    </div>
  );
}

export default AiNode;
